import { createContext } from 'react';

const CoreNavigationContext = createContext({});

export default CoreNavigationContext;
